import React from "react";

export const PrimaryButtonComponent = () => {
  return (
    <div className="h-10 w-36 md:w-44 flex justify-center items-center bg-primaryBlue rounded text-lg text-white font-newFont">
      <a href="mailto:contacto@auditech.app">Solicitar demo</a>
    </div>
  );
};
